export default function Main(){
    return(
        <footer>
            <p className="text-center">
                <a href="https://github.com/andredelmestre" className="nav-item" target="_blank"><i aria-hidden="true" className="fa fa-lg fa-github"></i></a>
                <a href="https://scholar.google.com.br/citations?user=zGc0bAQAAAAJ&hl=pt-BR&oi=ao" className="nav-item" target="_blank"><i aria-hidden="true" className="fa fa-lg fa-google"></i></a>
                <a href="https://www.linkedin.com/in/andr%C3%A9-lu%C3%ADs-del-mestre-martins-421b43a1/" className="nav-item" target="_blank"><i aria-hidden="true" className="fa fa-lg fa-linkedin"></i></a>
            </p>
        </footer>
    );
}